import React from 'react';
// import { PATH } from 'shared/constants';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import DefaultIcon from 'assets/icons/icon-open-account.svg';
import './Stepper.scss';

const Stepper = ({
  title, iconSrc, isStep1Active, isStep2Active, isStep3Active,
  isStep1Completed, isStep2Completed, intl,
}) => (
  <header className="stepper">

    <ul className="stepper__items">
      <li className={`${isStep1Active ? 'active' : ''} ${isStep1Completed ? 'completed' : ''}`}>
        <span>1</span>
        <em />
        <small>{intl.formatMessage({ id: 'account' })}</small>
      </li>
      <li className={`${isStep2Active ? 'active' : ''} ${isStep2Completed ? 'completed' : ''}`}>
        <span>2</span>
        <em />
        <small>{intl.formatMessage({ id: 'otp' })}</small>
      </li>
      <li className={`${isStep3Active ? 'active' : ''}`}>
        <span>F</span>
        <em />
        <small>{intl.formatMessage({ id: 'finish' })}</small>
      </li>
    </ul>

    <div className="stepper__details">
      <img src={iconSrc} alt={title} />
      <h4 className="stepper__details__title"><FormattedMessage id={title} /></h4>
    </div>
  </header>
);

Stepper.propTypes = {
  /** Title of stepper */
  title: PropTypes.string,
  /** icon source */
  iconSrc: PropTypes.string,
  /** 1st step */
  isStep1Active: PropTypes.bool,
  /** 2nd step */
  isStep2Active: PropTypes.bool,
  /** 3rd step */
  isStep3Active: PropTypes.bool,
  /** is isStep1 completed */
  isStep1Completed: PropTypes.bool,
  /** is Step2 Completed */
  isStep2Completed: PropTypes.bool,
};

Stepper.defaultProps = {
  title: 'auth.mobileVerification',
  iconSrc: DefaultIcon,
  isStep1Active: false,
  isStep2Active: false,
  isStep3Active: false,
  isStep1Completed: false,
  isStep2Completed: false,
};

export default injectIntl(Stepper);
